module Environments {
    module.directive("agentListItem", function () {
        return {
            templateUrl: "AgentListItemTemplate"
        };
    });
}